module.exports = __webpack_public_path__ + "img/advantage_icon_order.1be749c5.svg";